export const taskConstants = {
  TASK_LIST_REQUEST: 'TASK_LIST_REQUEST',
  TASK_LIST_SUCCESS: 'TASK_LIST_SUCCESS',
  TASK_LIST_FAILURE: 'TASK_LIST_FAILURE',
  TASK_LIST_CHANGED: 'TASK_LIST_CHANGED',
  TASK_LIST_PAGINATION: 'TASK_LIST_PAGINATION'
};
